import axios from "axios";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { Alert, Button, Container, Grid, Typography } from "@mui/material";

import { FormTextField } from "components/FormInputs";
import { useContext, useState } from "react";
import { AuthContext } from "contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Login() {

  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  const [isUserNotFound, setIsUserNotFound] = useState(false);
  
  const schema = yup.object().shape({
    userId: yup.string().required("ID를 입력해주세요."),
    pwd: yup.string().required("비밀번호를 입력해주세요")
  });

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  // 로그인
  const onLogin = (formData) => {
    axios.post(`/api/user/login`, formData)
    .then(res => {
      if (res.data) {
        setUser(res.data);
        navigate("/");
      } else {
        setIsUserNotFound(true);
      }
    })
    .catch(err => {
      alert("오류가 발생하였습니다. 관리자에게 문의하여 주세요.");
    })
  };

  return (
    <Container maxWidth="xs" sx={{marginTop: "75px", marginBottom: "75px"}}>
      <Grid container flexDirection="column" gap="16px">
        <Typography sx={{
          fontFamily: "NanumSquareExtraBold",
          fontSize: "1.5rem",
          textAlign: "center"
        }}>🔒&nbsp;로그인</Typography>

        {isUserNotFound &&
          <Alert severity="error" onClose={() => setIsUserNotFound(false)}>회원 정보를 찾을 수 없습니다.</Alert>
        }

        <FormTextField
          name="userId"
          label="ID"
          control={control}
          error={errors.userId}
          inputProps={{
            maxLength: "20"
          }}
        />

        <FormTextField
          name="pwd"
          label="Password"
          type="password"
          control={control}
          error={errors.pwd}
        />

        <Button variant="contained" onClick={handleSubmit(onLogin)}>로그인</Button>
        <Button variant="outlined" onClick={() => navigate("/signup")}>회원가입</Button>
      </Grid>
    </Container>
  );
}